import type { HelpTopicDetail } from './help-topic-detail.types';
import type { UiLanguageCode } from '@/lib/ui-languages';
import { HELP_TOPIC_DETAILS } from './help-topic-details.data';

import en from './locales/help-details-en.json';
import es from './locales/help-details-es.json';
import de from './locales/help-details-de.json';
import it from './locales/help-details-it.json';
import pt from './locales/help-details-pt.json';
import lb from './locales/help-details-lb.json';
import uk from './locales/help-details-uk.json';
import ru from './locales/help-details-ru.json';
import ar from './locales/help-details-ar.json';
import tr from './locales/help-details-tr.json';

type DetailMap = Record<string, HelpTopicDetail>;

/** Détails de fiches par langue UI (`fr` = source TS ; autres = JSON générés). */
export const HELP_TOPIC_DETAILS_BY_LANG: Partial<Record<UiLanguageCode, DetailMap>> = {
  fr: HELP_TOPIC_DETAILS,
  en: en as DetailMap,
  es: es as DetailMap,
  de: de as DetailMap,
  it: it as DetailMap,
  pt: pt as DetailMap,
  lb: lb as DetailMap,
  uk: uk as DetailMap,
  ru: ru as DetailMap,
  ar: ar as DetailMap,
  tr: tr as DetailMap,
};
